var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "a",
      {
        staticClass: "block group",
        attrs: {
          href: _vm.possibleLangPrefix + "/begeleiding/" + _vm.content.slug,
        },
      },
      [
        _c("div", { staticClass: "relative" }, [
          _c("div", { staticClass: "aspect-w-4 aspect-h-5 w-full" }),
          _vm._v(" "),
          _c("div", { staticClass: "absolute w-full h-full top-0 left-0" }, [
            _vm.content.acf.image
              ? _c(
                  "picture",
                  {
                    staticClass:
                      "absolute w-full h-full top-0 overflow-hidden left-0",
                  },
                  [
                    _c("img", {
                      staticClass:
                        "w-full h-full object-cover lazyload group-hover:scale-110 transition-transform duration-300 origin-center",
                      attrs: {
                        "data-src": _vm.content.acf.image.url,
                        alt: _vm.content.acf.image.title,
                      },
                    }),
                    _vm._v(" "),
                    _vm._m(0),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "mt-sm sm:mt-[1.5625rem] group-hover:text-primary-400 transition-colors",
          },
          [
            _c("div", { staticClass: "flex justify-between" }, [
              _c("h3", {
                staticClass:
                  "group-hover:text-primary-400 text-h4 sm:text-h3 transition-colors",
                domProps: { innerHTML: _vm._s(_vm.content.title.rendered) },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.distanceObject.distance,
                      expression: "distanceObject.distance",
                    },
                  ],
                  staticClass: "shrink-0 ml-xs text-primary-400 text-sm pt-xxs",
                },
                [_vm._v(" " + _vm._s(_vm.distanceString))]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-[.5rem] text-gray-500 text-xs" },
              [
                _vm._l(_vm.content.categories_objects, function (cat, index) {
                  return _c("span", { key: index }, [
                    _c("span", { staticClass: "mr-xxs" }, [
                      _vm._v(" " + _vm._s(cat.name) + ", "),
                    ]),
                  ])
                }),
                _vm._v(" "),
                _vm.locationString
                  ? _c("div", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.locationString) +
                          "\n                "
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "text-primary-400 bg-gray-800 px-xs py-[20px] flex items-center justify-center absolute bottom-0 right-0",
      },
      [
        _c(
          "div",
          {
            staticClass:
              "absolute -translate-x-full w-auto h-full top-0 left-xxs",
          },
          [
            _c("img", {
              staticClass: "w-auto h-full",
              attrs: { src: "/images/brush_left_default.png", alt: "" },
            }),
          ]
        ),
        _vm._v(" "),
        _c("i", {
          staticClass:
            "fa-regular fa-arrow-right group-hover:translate-x-xxs duration-300 transition-transform",
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }